import type { ColumnMapping } from "./types";

export function hasBlockingUploadMappingItems(items: ColumnMapping[]): boolean {
  const activeItems = items.filter(item => item.valid && !item.disabled);

  const hasUnexpectedType = activeItems.some(item => item.type !== "parameter" && item.type !== "measurement");
  const hasParameter = activeItems.some(item => item.type === "parameter");
  const hasMeasurement = activeItems.some(item => item.type === "measurement");

  return hasUnexpectedType || !hasParameter || !hasMeasurement;
}
